import React from 'react'
import Controller from './Controller'
import View from './View'
import CampaignPage from 'Containers/Campaigns/Page'
import { PageWrapper } from 'Components/Campaigns/Page/PageWrapper'

export default props => (
  <CampaignPage
    active={props.nav}
    campaignId={props.match.params.campaignId}
    history={props.history}
    match={props.match}
    location={props.location}
  >
    <PageWrapper className="campaign-page-wrapper">
      <Controller
        campaignId={props.match.params.campaignId}
        match={props.match}
      >
        <View />
      </Controller>
    </PageWrapper>
  </CampaignPage>
)



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/Page/MasterSchedule/index.js